import script from "./IndicatorsStatistic.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndicatorsStatistic.vue?vue&type=script&setup=true&lang=ts"

import "./IndicatorsStatistic.vue?vue&type=style&index=0&id=11d6781c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d6781c"]])

export default __exports__